import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import AboutAward from "../containers/about/about-awards";
import AboutBannerContainer from "../containers/about/about-banner-container";
import BrandTwoContainer from "../containers/global/brand-two";
import SkillContainer from "../containers/global/skill";
import Layout from "../layouts";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import { Container } from "reactstrap";
import IconBoxContainer from "../containers/home/icon-box";

const AboutPage = () => {
    return (
        <React.Fragment>
            <Layout>
                {/* <SEO title="SHH - About Us" /> */}
                <div className="main-wrapper">
                    <Header />
                    <AboutBannerContainer />
                    <IconBoxContainer type="contact" />
                    <BrandTwoContainer />
                    <AboutAward />
                    {/* <SkillContainer /> */}
                    <div className="section section-padding mt-n1 mb-n2">
                        <div
                            className="container"
                            style={{
                                paddingTop: "70px",
                                borderTop:
                                    "solid 1px rgba(255, 255, 255, 0.15)",
                            }}
                        >
                            <p
                                style={{
                                    fontFamily: "inter, sans-serif ",
                                    fontSize: "16px",
                                }}
                            >
                                With more than 8 years of experience in various
                                fields including Marketing, Research, Academia,
                                and Strategic fields, Ahmed found out his true
                                passion; human holistic wellbeing, and how to
                                find innovative ways to help people achieve
                                their full potential.
                                <br />
                                <br />
                                Ahmed Sedky is a 30-year-old Egyptian man who
                                believes that everyone is capable of unlocking
                                their inner potential. Just as any other guy his
                                age, Ahmed has grown fond of football and cardio
                                exercises, along with his strategical mindset
                                and mind mapping, he started planning for this
                                project. After years of dedication and hard work
                                in different fields and projects along with
                                various researchers, business leaders, experts,
                                and motivators to find out the best way to
                                optimize people’s mind, body, and soul in
                                harmony through modern science.
                                <br />
                                <br />
                                Ahmed Sedky, believes that Soul Harmony House is
                                capable to bring out the best in everyone,
                                through our expanding services, research,
                                publications and development, community
                                engagement, holistic education, sustainability
                                practices, technology integration, financial
                                sustainability, client centred approach, and our
                                philanthropy and outreach.
                            </p>
                        </div>
                    </div>

                    <Footer />
                </div>
                <ScrollToTop />
            </Layout>
        </React.Fragment>
    );
};

export default AboutPage;
